module.exports = __webpack_public_path__ + "media/frontend/svg/logo3-4ff0b5b79778d07f985dd852abefbcbd.svg";